import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: 'app-snackbar-message',
	templateUrl: './snackbar-message.component.html',
})
export class SnackbarMessageComponent {
	constructor(
		@Inject(MAT_SNACK_BAR_DATA)
		public data: { html: string; borderStatusColor: 'green' | 'red'; iconStatusColor: 'green' | 'red' },
		public snackBar: MatSnackBar
	) {}
}
